import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes, { any } from 'prop-types';
import moment from 'moment';
import {
    ToggleSwitch,
    Select,
} from '../../../Form';
import USAPApplicationPopUp from '../../../PopUps/USAPApplicationPopUp';
import { required } from '../../../../utils/validation';
import { usapDefaultQuestion, eventQuestionTypeIds, TmsEventUsapApplicationStatusTypes } from '../../../../utils/eventConstants';
import { getUsapDefaultQuestionIndex } from '../../../../utils/events';

const USAPVerificationType = (props) => {
    const {
        field,
        value,
        formApi,
        usapVerificationTypeField,
        playersRegistered,
    } = props;

    const coreUI = useSelector(({ coreUI }) => coreUI);

    const { usapVerificationTypes } = coreUI?.types?.tms || {};
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const handleOnClick = (value) => {
        formApi.setValue(field, value);
        if (value) {
            const usapDefaultQuestionIndex = getUsapDefaultQuestionIndex(formApi?.values?.eventQuestions);
            const defaultQuestion = {
                text: usapDefaultQuestion,
                required: true,
                type: eventQuestionTypeIds.THIRDPARTY_ID,
            };
            if (usapDefaultQuestionIndex === -1) {
                const { eventQuestions } = formApi.values;
                eventQuestions.unshift(defaultQuestion);
                formApi.setValue('eventQuestions', eventQuestions);
            }

            formApi.setValue('removeWithdrawnPlayersFromStandings', true);
        } else {
            formApi.setValue('removeWithdrawnPlayersFromStandings', false);
        }

        setShowConfirmationPopup(false);
    };

    const handleUSAPVerificationTypeToggle = (val, usapVerificationTypeField, formApi) => {
        const usapDefaultQuestionIndex = getUsapDefaultQuestionIndex(formApi?.values?.eventQuestions);
        if (!val) {
            formApi.setValue(usapVerificationTypeField, null);
            formApi.setError(usapVerificationTypeField, null);
            if (usapDefaultQuestionIndex !== -1) {
                const filterValue = formApi.values.eventQuestions.filter(val => val.type !== eventQuestionTypeIds.THIRDPARTY_ID);
                formApi.setValue('eventQuestions', filterValue);
            }
        }
        if (val) {
            setShowConfirmationPopup(true);
        } else {
            formApi.setValue('removeWithdrawnPlayersFromStandings', false);
        }
    };

    const disableUsap = (playersRegistered, formApi) => {
        if (formApi?.values?.eventSchedule?.registrationEndUtc && moment.utc().isSameOrAfter(formApi?.values?.eventSchedule?.registrationEndUtc)) {
            return true;
        }
        if (parseInt(formApi?.values?.usapApplicationStatusId) === TmsEventUsapApplicationStatusTypes.DECLINED) {
            return true;
        }
        return playersRegistered;
    };

    return (
        <div className={`col-12 mb24`}>
            <div className="div div16" />
            <ToggleSwitch
                id={'hasUsapVerificationTypeId'}
                field={field}
                formGroupCssClass={`mt16`}
                label="Apply for USA Pickleball (USAP) event sanctioning?"
                reverse={false}
                onChange={val => handleUSAPVerificationTypeToggle(val, usapVerificationTypeField, formApi)}
                disabled={disableUsap(playersRegistered, formApi)}
            />

            {value && showConfirmationPopup && (
                <USAPApplicationPopUp
                    onConfirmClick={() => handleOnClick(true)}
                    onCloseClick={() => handleOnClick(false)}
                />
            )}

            {value && (
                <Select
                    id="usapVerificationTypeId"
                    formGroupCssClass={`mb0`}
                    field={usapVerificationTypeField}
                    value={value}
                    emptyOption="Select a sanctioning type"
                    options={usapVerificationTypes}
                    validate={required}
                    disabled={disableUsap(playersRegistered, formApi)}
                    data-testid="event-edit.usap-verification-type-id-select"
                />
            )}
        </div>
    );
};

USAPVerificationType.propTypes = {
    field: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
    usapVerificationTypeField: PropTypes.string.isRequired,
    playersRegistered: PropTypes.bool,
};

USAPVerificationType.defaultProps = {
    playersRegistered: false,
};

export default USAPVerificationType;
